var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_32",
    "data-name": "Union 32",
    d: "M-8481.181-6309.6a1.79,1.79,0,0,1-1.791-1.787v-4.255a1.1,1.1,0,0,0-.321-.78,1.1,1.1,0,0,0-.783-.324h-.015a1.093,1.093,0,0,0-.768.328,1.087,1.087,0,0,0-.319.776v4.255a1.791,1.791,0,0,1-1.789,1.787h-6.1a1.932,1.932,0,0,1-1.932-1.927v-2.913c0-1.044,0-2.168,0-3.208,0-1.249,0-2.377,0-3.106a2.865,2.865,0,0,1,.843-2.034l8.583-8.6a2.1,2.1,0,0,1,1.494-.618,2.1,2.1,0,0,1,1.5.618l8.585,8.6a2.852,2.852,0,0,1,.625.936,2.869,2.869,0,0,1,.22,1.1v9.218a1.932,1.932,0,0,1-1.932,1.93Zm-2.9-8.805a2.737,2.737,0,0,1,1.953.808,2.75,2.75,0,0,1,.813,1.955v4.255a.129.129,0,0,0,.13.128h6.1a.271.271,0,0,0,.271-.271v-9.218a1.208,1.208,0,0,0-.354-.861l-8.59-8.6a.451.451,0,0,0-.322-.134.44.44,0,0,0-.317.134l-8.588,8.6a1.214,1.214,0,0,0-.355.863v2.352c0,1.236,0,2.665,0,3.967v2.906a.269.269,0,0,0,.271.269h6.1a.128.128,0,0,0,.128-.128v-4.255a2.744,2.744,0,0,1,.8-1.942,2.749,2.749,0,0,1,1.929-.821Z",
    transform: "translate(8496.574 6333.298)",
    fill: "#5b788f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.81e35a32edf909d6083b6b2b644911fd.svg";
export { ForwardRef as ReactComponent };